import { TxnService } from 'app/services/txn.service';
/**
 * 登入首頁的label.
 */
export class CcmotlgacLabeltBean {

    labelUser: string;
    labelUserIxd: string; // 顧客ID/代號'cot00000497'
    labelUserCode: string; // 顧客代號
    labelUserName: string; // 使用者名稱'cot00003649'
    labelPin: string; // 密碼'common00001627'
    labelCaptcha: string; // 驗證碼'cot00003248'
    labelLoginButton: string; // 登入'cot00005726'
    labelCleanButton: string; // 清除'cot00001198'

    /**
     * GIB-4681 調整文字顯示 label9、label10、label26.
     */
    constructor(txnService: TxnService) {
        this.labelUserIxd = txnService.transform('顧客ID/代號', 'cot00000497', null);
        this.labelUserCode = txnService.transform('顧客代號', 'cot00001039', null);
        this.labelUserName = txnService.transform('使用者名稱', 'cot00003649', null);
        this.labelPin = txnService.transform('密碼', 'common00001627', null);
        this.labelCaptcha = txnService.transform('驗證碼', 'cot00003248', null);
        this.labelLoginButton = txnService.transform('登入', 'cot00005726', null);
        this.labelCleanButton = txnService.transform('清除', 'cot00001198', null);

        this.labelUser = this.labelUserIxd;
    }

}

